import { render, staticRenderFns } from "./SearchIncidents.vue?vue&type=template&id=bcb08f58&"
import script from "./SearchIncidents.vue?vue&type=script&lang=js&"
export * from "./SearchIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports